var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lives-wrapbox"},[(_vm.mode == 1)?[_c('liveChecked',{attrs:{"checkedList":_vm.info.subjects}})]:_vm._e(),(_vm.mode == 2)?[_c('livesCheck',{attrs:{"checkedList":_vm.info.subjects},on:{"seleclted":_vm.checkLives}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }